const notificationActionConstants = {
  GET_NOTIFICATION_SETTINGS: 'GET_NOTIFICATION_SETTINGS',
  GET_OPT_OUT_SETTINGS: 'GET_OPT_OUT_SETTINGS',
  UPDATE_NOTIFICATION_SETTINGS: 'UPDATE_NOTIFICATION_SETTINGS',
  GET_NOTIFICATIONS_LIST: 'GET_NOTIFICATIONS_LIST',
  GET_NOTIFICATIONS_LIST_SUCCESS: 'GET_NOTIFICATIONS_LIST_SUCCESS',
  GET_NOTIFICATIONS_LIST_ERROR: 'GET_NOTIFICATIONS_LIST_ERROR',
  SET_READ_ALL_SUCCESS: 'SET_READ_ALL_SUCCESS',
  SET_READ_ALL_ERROR: 'SET_READ_ALL_ERROR',
  SET_READ_ALL: 'SET_READ_ALL',
  SET_READ: 'SET_READ',
  SET_READ_SUCCESS: 'SET_READ_SUCCESS',
  SET_READ_ERROR: 'SET_READ_ERROR',
};
export default notificationActionConstants;
